import BaseComponent from "@js/components/base_component.jsx";

class EuiUsersIndexTable extends BaseComponent {

  render() {
    return ( this.props.table && this.props.table.length > 0 ) ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.email") }</th>
            <th className="column-name text-right" style={{width: "100px"}}>{ t("headings.ui") }</th>
            <th className="column-name text-right" style={{width: "100px"}}>{ t("headings.api") }</th>
            <th className="column-name text-right" style={{width: "100px"}}>{ t("headings.injection") }</th>
            <th className="column-name text-right" style={{width: "75px"}}>{ t("headings.twofactor") }</th>
            <th className="column-actions" style={{width: "200px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification
        type={I18n.t("sections.users")}
        offerNew={ this.props.library.system_configuration.allow_edit_engine_users }
      />
    );
  }

  _renderRows() {
    return this.props.table.map((user, i) => {
      return (
        <tr key={ i }>
          <td>{ user.email }</td>
          <td className="text-right">{ user.is_disabled ? "disabled" : user.permission_ui        }</td>
          <td className="text-right">{ user.is_disabled ? "disabled" : user.permission_api       }</td>
          <td className="text-right">{ user.is_disabled ? "disabled" : user.permission_injection }</td>
          <td className="text-right">{ user.has_otp_secret ? "yes" : "no" }</td>
          <td className="text-right index-buttons">
            {
              user.id && (
                <div>
                  {
                    this.props.library.system_configuration.allow_edit_engine_users && (
                      <ButtonEdit
                        href={ Routes.edit_eui_user_path(user.id, { return_to: window.location.href }) }
                        size="small"
                      />
                    )
                  }
                  <ButtonView
                    href={ Routes.eui_user_path(user.id) }
                    size="small"
                  />
                </div>
              )
            }
          </td>
        </tr>
      );
    });
  }

}

export default EuiUsersIndexTable;
